import React from 'react';

type TableCellEditAlign = 'left' | 'right' | 'center';

interface TableCellEditShellProps {
  isEditing: boolean;
  align?: TableCellEditAlign;
  measure: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * 編集開始時も表示時と同じセル幅を保つ。
 * measure（NumberCounter 等）を残して幅を確保し、input はその上に重ねる。
 */
export const TableCellEditShell: React.FC<TableCellEditShellProps> = ({
  isEditing,
  align = 'left',
  measure,
  children,
}) => (
  <div
    className={[
      'table-cell-edit-shell',
      isEditing ? 'is-editing' : '',
      align !== 'left' ? `align-${align}` : '',
    ]
      .filter(Boolean)
      .join(' ')}
  >
    <span className="table-cell-edit-measure" aria-hidden={isEditing}>
      {measure}
    </span>
    {isEditing ? children : null}
  </div>
);
